import { isFeatureEnabled, useIsFeatureEnabled } from './featureFlags';
import { DISABLE_SBOM_POLICY } from '../../../shared/featureFlags/flagNames';

/**
 * Frontend helper function for checking if the user's org has the SBOM Policy feature enabled.
 */
export const isSBOMPolicyEnabled = () =>
  !isFeatureEnabled(DISABLE_SBOM_POLICY);

/**
 * Frontend helper hook for checking if the user's org has the SBOM Policy feature enabled
 * and memoized the result across re-renders.
 */
export const useIsSBOMPolicyEnabled = () => !useIsFeatureEnabled(DISABLE_SBOM_POLICY);
